import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import {
  ArbitrageMovementReportDTO,
  UserInvestmentPlansAvailableReportsResponseDTO
} from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlansReportsRequest extends Request<
  never,
  UserInvestmentPlansAvailableReportsResponseDTO
> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `/broad${options?.version ?? '/v1'}/me/investment_plans/available_report`
    });
  }

  public execute(): Observable<ArbitrageMovementReportDTO[]> {
    return super
      .execute()
      .pipe(
        map(
          (response: HttpResponse<UserInvestmentPlansAvailableReportsResponseDTO>) =>
            response.body?.broadArbitrageMovementModel
        )
      );
  }
}

export function getInvestmentPlansReports(
  options?: RequestOptions<never>
): InvestmentPlansReportsRequest {
  return new InvestmentPlansReportsRequest(options);
}
